/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cap_3_DescInputs */

const en_mk_cap_3_desc = /** @type {(inputs: Mk_Cap_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morning recaps, invoice reminders, weekly reports — they run themselves and post into the channel you choose.`)
};

const id_mk_cap_3_desc = /** @type {(inputs: Mk_Cap_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekap pagi, pengingat invoice, laporan mingguan — jalan sendiri, hasilnya masuk ke channel yang Anda tentukan.`)
};

/**
* | output |
* | --- |
* | "Morning recaps, invoice reminders, weekly reports — they run themselves and post into the channel you choose." |
*
* @param {Mk_Cap_3_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cap_3_desc = /** @type {((inputs?: Mk_Cap_3_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cap_3_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cap_3_desc(inputs)
	return en_mk_cap_3_desc(inputs)
});